import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";

import { GlobalLoadingFacade } from "state/global-loading.facade";

@Component({
  selector: "app-global-loading-overlay",
  templateUrl: "./global-loading-overlay.component.html",
  styleUrls: ["./global-loading-overlay.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MatProgressSpinnerModule],
})
export class GlobalLoadingOverlayComponent {
  private readonly globalLoading = inject(GlobalLoadingFacade);

  protected readonly isLoading = this.globalLoading.isLoading;
}
